import '@babel/polyfill'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import {VueMasonryPlugin} from 'vue-masonry'

import AddToCartButton from '@Shared/components/catalog/AddToCartButton'
import InlineUpgrade from '@Shared/components/catalog/InlineUpgrade'
import PackageOptionFrameProduct from '@Shared/components/catalog/PackageOption/PackageOptionFrameProduct'
import PackageOptionPreviewModal from '@Shared/components/catalog/PackageOptionPreviewModal'
import PhotoBook from './components/PhotoBook/PhotoBook'
import PromoBanner from '@Shared/components/PromoBanner'
import RetouchingInputs from '@Shared/components/catalog/RetouchingInputs'
import RetouchingModal from '@Shared/components/catalog/RetouchingModal/RetouchingModal'
import SelectPhotoModal from '@Shared/components/catalog/SelectPhotoModal/SelectPhotoModal'
import SingleFramePackage from './components/SingleFramePackage/SingleFramePackage'
import V2Contentful from '@Shared/plugins/V2Contentful'
import YouMayAlsoLike from '@Shared/components/catalog/YouMayAlsoLike/YouMayAlsoLike'
import { MediaQueries } from 'vue-media-queries'

// letter jacket identity components
import HowToOrder from '../../letter-jackets/shared/components/HowToOrder/HowToOrder'
import LetterJacketAddToCartButton from '../../letter-jackets/catalog-details/components/AddToCartButton'
import LetterJacketPackageImage from '../../letter-jackets/catalog-details/components/LetterJacketPackageImage'
import LetterJacketPlaceholderImage from '../../letter-jackets/catalog-details/components/LetterJacketPlaceholderImage'
import LetterJacketSampleImages from '../../letter-jackets/catalog-details/components/LetterJacketSampleImages/LetterJacketSampleImages'
import LetterJacketSizing from '../../letter-jackets/catalog-details/components/JacketSizing/JacketSizing'
import OptionProductConfigurations from '../../letter-jackets/catalog-details/components/PackageOptions/OptionProduct/OptionProductConfigurations'
import PackageDetails from '../../letter-jackets/catalog-details/components/PackageDetails'
import PackageOptions from '../../letter-jackets/catalog-details/components/PackageOptions/PackageOptions'
import SleevePatchSelection from '../../letter-jackets/catalog-details/components/SleevePatchSelection/SleevePatchSelection'

import store from './store'
import _ from 'lodash'
import VueToastr from '@deveodk/vue-toastr'
import VueSiteIdentity from '@Shared/plugins/VueSiteIdentity'
import CatalogPagesMixin from '@Shared/mixins/catalog-pages'

const mediaQueries = new MediaQueries()
Vue.use(mediaQueries)

Vue.use(VueAxios, axios)
Vue.use(VueToastr)
Vue.use(VueMasonryPlugin)
Vue.use(V2Contentful)
Vue.use(VueSiteIdentity)

/* eslint-disable no-new */
new Vue({
  el: '#catalog-details-app',
  store,
  mediaQueries,
  components: {
    AddToCartButton,
    HowToOrder,
    InlineUpgrade,
    LetterJacketAddToCartButton,
    LetterJacketPackageImage,
    LetterJacketPlaceholderImage,
    LetterJacketSampleImages,
    LetterJacketSizing,
    OptionProductConfigurations,
    PackageDetails,
    PackageOptionFrameProduct,
    PackageOptionPreviewModal,
    PackageOptions,
    PhotoBook,
    PromoBanner,
    RetouchingInputs,
    RetouchingModal,
    SelectPhotoModal,
    SingleFramePackage,
    SleevePatchSelection,
    YouMayAlsoLike
  },
  mixins: [
    CatalogPagesMixin
  ],
  data () {
    return {
      allowCropping: window.pageData.catalogDetails.allowCropping,
      allowRetouching: window.pageData.catalogDetails.allowRetouching,
      firstOptionProduct: window.pageData.catalogDetails.firstOptionProduct,
      frameId: window.pageData.catalogDetails.defaultSelectedFrameId,
      offerPackage: window.pageData.catalogDetails.offerPackage,
      packageOptions: window.pageData.catalogDetails.packageOptions,
      retouchingModalContent: window.pageData.catalogDetails.retouchingModalContent,
      retouchingViewModel: window.pageData.catalogDetails.retouchingViewModel,
      retouchingsInCart: window.pageData.catalogDetails.retouchingsInCart,
      selectDifferentPhotoViewModel: window.pageData.catalogDetails.selectDifferentPhotoViewModel,
      showBeautifyAllRetouchingModal: window.pageData.catalogDetails.showBeautifyAllRetouchingModal,
      showRetouchingModalOnAddToCart: window.pageData.catalogDetails.showRetouchingModalOnAddToCart,
      youMayAlsoLikeModuleContent: window.pageData.catalogDetails.youMayAlsoLikeModuleContent
    }
  },
  computed: {
    isPhotoBookPackage () {
      return this.$store.state.isPhotoBookPackage
    },
    promoBanner () {
      return this.$store.state.catalogPageCommon.promoBanner
    },
    retouchingModalShowDisplayOnFrameSelectToggle () {
      return this.showRetouchingModalOnAddToCart === false && this.showBeautifyAllRetouchingModal === false
    },
    selectedRetouchings () {
      return this.$store.state.catalogPageCommon.selectedRetouchings
    },
    showPageTopBackNav () {
      return !this.isLetterJacket
    }
  },
  watch: {
    selectedRetouchings (v, ov) {
      let alreadyInCartCount = 0

      if (_.keys(this.retouchingsInCart).indexOf(this.frameId) > -1) {
        alreadyInCartCount = this.retouchingsInCart[this.frameId].length
      }

      let retouchingsCount = this.selectedRetouchings.length + alreadyInCartCount

      document.dispatchEvent(new CustomEvent('retouchings.updated', {
        detail: {
          numberRetouchingsSelected: retouchingsCount,
          frameId: this.frameId
        }
      }))
    }
  },
  created () {
    document.addEventListener('modal-image-select', e => {
      this.frameId = e.detail.frameId
    })
  },
  methods: {
    handleRetouchingAdded (data) {
      this.$store.commit('addSelectedRetouching', {
        frameId: parseInt(data.frameId, 10),
        offerPackageId: parseInt(data.offerPackageId, 10)
      })
    },
    handleRetouchingRemoved (data) {
      this.$store.commit('removeSelectedRetouching', data)
    },
    handleRetouchingFrameChanged () {
      // currently photo book packages are the only packages on the Catalog/Details page that support multi-frame retouching
      // so only need to clear retouchings when it's a single frame package.
      // TODO need to make this less a one-off and more systemic variable. probably need to know if a package is a "multi-frame" package or not.
      if (this.isPhotoBookPackage === false) {
        // reset the selected retouchings if the frame changes for a non-multi-frame package
        this.$store.commit('resetSelectedRetouchings')
      }
    },
    handleAddToCartButtonClick () {
      // this method should only fire/work with single frame packages at this point

      let singlePackageSelectionIsValid = this.$store.getters.singlePackageFrameIsValid

      if (singlePackageSelectionIsValid === true) {
        document.getElementById('add-to-cart-form').submit()
      } else {
        this.$store.commit('setShowSingleFramePackageValidationError', true)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./WebResources/vue/default/catalog-details/main.js